export default "__VITE_ASSET__DAXZza$a__"